<template>
	<div class="container" :class="{ loading: modelLoadingProgress < 1 }">
		<ModelViewMulticare v-if="$store.state.activeProduct === 'multicare'" @load="onModelLoad"/>
    <ModelViewEleganza v-if="$store.state.activeProduct === 'eleganza4'" @load="onModelLoad"/>
    <ModelViewSprint v-if="$store.state.activeProduct === 'sprint'" @load="onModelLoad"/>
    <ModelViewAve v-if="$store.state.activeProduct === 'ave2'" @load="onModelLoad"/>
		<ModelViewGracie v-if="$store.state.activeProduct === 'gracie'" @load="onModelLoad"/>

		<TopBar />

		<img :class="`${$store.state.activeProduct}-logo`" :src="require(`./assets/images/products/${$store.state.activeProduct}/logo.png`)" />

		<img
			src="./assets/images/linet-logo.svg"
			class="logo"
			:class="{
				'logo--front': productSelectorOpen,
				'hidden': explanationPaneOpen
			}"
		/>

		<transition>
			<div
				v-if="!hideControlPanel && activePrimaryNavigation === 'controls' && secondaryNavigationOpen"
				class="control-panel"
        :class="[
          `control-panel--${$store.state.activeProduct}`,
          {overlay : secondaryNavigationHover}
        ]"
			>
				<IBoard />
				<span class="control-panel__close">
					<svg
						class="icon icon--grey icon--20"
						@click="$store.commit('setHideControlPanel', true)"
					>
						<use href="#icon-close"></use>
					</svg>
				</span>
			</div>
		</transition>

		<Navigation
			@request-camera-position="setCameraPosition"
			@request-model-materials-visibility="triggerModelMaterialsVisibility"
		/>

		<ExplanationPane />

		<transition>
			<div v-if="modelLoadingProgress < 1" class="loading-screen">
				<Loader :progress="modelLoadingProgress" />
				<img class="logo" src="./assets/images/linet-logo.svg" />
			</div>
		</transition>

		<ProductSelector />
	</div>
</template>

<script>
import { mapState } from 'vuex'
import Loader from './components/Loader.vue'
import TopBar from './components/TopBar.vue'
import Navigation from './components/Navigation.vue'
import ExplanationPane from './components/ExplanationPane.vue'
import IBoard from './components/IBoard.vue'
import ProductSelector from './components/ProductSelector.vue'
import ModelViewMulticare from './components/modelViews/Multicare.vue'
import ModelViewEleganza from './components/modelViews/Eleganza4.vue'
import ModelViewSprint from './components/modelViews/Sprint.vue'
import ModelViewAve from './components/modelViews/Ave.vue'
import ModelViewGracie from './components/modelViews/Gracie.vue'

export default {
	name: 'App',
	data() {
		return {
			productId: null
		}
	},
	components: {
		Loader,
		TopBar,
		Navigation,
		ExplanationPane,
		IBoard,
		ProductSelector,
		ModelViewMulticare,
    ModelViewEleganza,
    ModelViewSprint,
    ModelViewAve,
		ModelViewGracie
	},
	computed: mapState({
		activePrimaryNavigation: state => state.navigation.activePrimary,
		secondaryNavigationOpen: state => state.navigation.secondaryOpen,
		secondaryNavigationHover: state => state.navigation.secondaryHover,
		hideControlPanel: state => state.hideControlPanel,
		explanationPaneOpen: state => state.explanationPaneOpen,
		modelLoadingProgress: state => state.modelLoadingProgress
	}),
	beforeCreate() {
    // if (localStorage.getItem('linetSelectedProduct')) {
    //   this.$store.dispatch('switchProduct', localStorage.getItem('linetSelectedProduct'))
    // }
	},
	mounted() {
		setTimeout(() => {
			this.$nextTick(() => {
				if (this.$route.params.id) {
					this.$store.dispatch('switchProduct', this.$route.params.id)
					localStorage.setItem('linetSelectedProduct', this.$route.params.id)
					this.productId = this.$route.params.id
				} else {
					if (localStorage.getItem('linetSelectedProduct')) {
						this.$store.dispatch('switchProduct', localStorage.getItem('linetSelectedProduct'))
					}
					this.productId = true
				}
			})
		}, 100)
	}
}
</script>

<style lang="scss">
#app {
	height: 100vh;
}

.container {
	height: 100%;
}

.loading-screen {
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	position: absolute;
	background-color: rgba(256, 256, 256, 1);
	transition: opacity 500ms ease;

	> div {
		position: absolute;
		top: 50%;
		left: 50%;
		width: 240px;
		height: 240px;
		transform: translate(-50%, -50%);
	}

	&.v-enter-from, &.v-leave-to {
		opacity: 0;
	}
}

.logo {
	position: absolute;
	width: 150px;
	height: auto;
	right: 50px;
	bottom: 40px;
	z-index: 0;
	transition: z-index 1ms linear 500ms, opacity 300ms ease;

	&--front {
		z-index: 100;
		transition: z-index 1ms linear, opacity 300ms ease;
	}
}

.multicare-logo {
	position: absolute;
  width: 275px;
  height: auto;
  left: 5px;
  top: 50px;
}

.eleganza4-logo {
	position: absolute;
  width: 275px;
  height: auto;
  left: 5px;
  top: 50px;
}

.sprint-logo {
	position: absolute;
  width: 275px;
  height: auto;
  left: 5px;
  top: 43px;
}

.ave2-logo {
	position: absolute;
  width: 145px;
  height: auto;
  left: 0;
  top: 42px;
}

.gracie-logo {
	position: absolute;
  width: 185px;
  height: auto;
  left: 0;
  top: 45px;
}

.control-panel {
	position: absolute;
	left: 30px;
	bottom: 25px;
	transition: transform 500ms ease;
	// transform: translate3d(0, 0, 0.1px);

	&.v-enter-active {
		transition: transform 500ms ease, opacity 300ms ease;
	}
	&.v-leave-active {
		transition: transform 500ms ease, opacity 300ms ease 200ms;
	}

	&.v-enter-from, &.v-leave-to {
		opacity: 0;
		transform: translate3d(0, calc(100% + 25px), 0.1px);
	}

	@media screen and (max-height: 890px) {
		left: 80px;
	}

  &::after {
    transition: 0.25s ease-out;
    z-index: -1;
    position: absolute;
    content: '';
    border-radius: 10px;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba($color: #b2b2b2, $alpha: 0);
  }

  &.overlay {
    &::after {
      z-index: auto;
      transition: 0.25s ease-out;
      background-color: rgba($color: #b2b2b2, $alpha: 0.9);
    }
  }

  &--sprint {
    width: 202px;
    height: 334px;

    @media screen and (max-height: 1000px) {
      left: 80px;
    }

    &::after {
      border-radius: 16px;
    }
  }

	&__close {
		display: flex;
		top: -10px;
		right: -35px;
		position: absolute;
		padding: 10px 10px 60px 10px;

		svg {
			opacity: 0;
			border-radius: 20px;
			background-color: $clrWhite;
			transition: opacity 200ms ease;
			cursor: pointer;
		}

		&:hover svg {
			opacity: 1 !important;
		}
	}

	&:hover &__close svg {
		opacity: 0.8;
	}
}
</style>
